import React, {
  useEffect,
  useCallback,
  useState,
  useMemo,
  useRef,
} from 'react';
import SearchCondition from './components/search_condition/index';
import CardConsolidationResult from './components/card_consolidation_result/index';
import { useLocation, history } from 'umi';
import { useDispatch } from 'dva';
import qs from 'qs';
import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  FormControl,
  TextField,
  Button,
  FormHelperText,
} from '@material-ui/core';
import CardMergeStyled from './cardMergeStyled';
import ReplayIcon from '@material-ui/icons/Replay';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import ModalML from '@/components/ModalML';
import MergeModal from './components/merge_modal/MergeModal';
import dayjs from 'dayjs';
import { useIntl } from 'umi';
import { createOid } from '@/utils/eventtracing';

export default () => {
  const intl = useIntl();
  const { formatMessage } = intl;

  const dispatch = useDispatch();
  const location = useLocation();
  const {
    handleSubmit,
    control,
    // reset,
    errors,
    setValue,
    watch,
    // register,
  } = useForm({
    defaultValues: {
      // title,
      // type,
      // status,
    },
  });
  const [modification, setModification] = useState({});
  const { query, pathname } = location;
  const { memberCode, mobile, pageNum = '1', pageSize = '1', time } = query;
  const [mergeOpen, setMergeOpen] = useState(false);
  const [adminId, setAdminId] = useState();
  const [secondaryId, setSecondaryId] = useState();

  const [adminCard, setAdminCard] = useState({});

  const [secondaryCard, setSecondaryCard] = useState({});
  const [submitData, setSubmitData] = useState();

  const watchReason = watch('remark');
  const timestamp = dayjs().format('YYYY-MM-DD HH-mm-ss');
  const searchRef = useRef();
  const saveRef = useRef();
  const [isSearch, setIsSearch] = useState(false);

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        pageSize,
        pageNum: '1',
        time: timestamp,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  // 点击重置清除数据
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 1,
        pageNum: '1',
      })}`,
    );
    dispatch({
      type: 'memberManagement/clearMemberList',
      payload: {
        values: [],
      },
    });
  };

  // 获取列表
  const fetchData = useCallback(() => {
    const values = {
      memberCode,
      mobile,
      // name,
      pageNum,
      pageSize,
      time,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'memberManagement/getMemberList',
      payload: {
        values,
      },
    });
  }, [dispatch, pageNum, pageSize, modification, mobile, memberCode, time]);

  useEffect(() => {
    if (memberCode || mobile) {
      fetchData();
    } else {
      if (isSearch) {
        window.NE_DAWN.trigger(searchRef.current, {
          event: '_ec', // 事件名
          params: {}, // 事件公参
        });
      }
      setIsSearch(false);
      dispatch({
        type: 'memberManagement/clearMemberList',
        payload: {
          values: [],
        },
      });
    }
  }, [fetchData, memberCode, mobile]);

  const onSubmitSuccess = () => {
    window.NE_DAWN.trigger(saveRef.current, {
      event: '_ec', // 事件名
      params: {
        masterCardId: submitData.masterCardId,
        replicaCardId: submitData.replicaCardId,
        remark: submitData.remark,
      }, // 事件公参
    });
    dispatch({
      type: 'cardConsolidation/handleMergeCard',
      payload: {
        values: {
          masterCardId: submitData.masterCardId,
          replicaCardId: submitData.replicaCardId,
          remark: submitData.remark,
        },
      },
      callback: (res) => {
        if (res.code === 0) {
          window.message.toast({
            type: 'success',
            message: formatMessage({ id: 'adjustment.merge.n01.lbl17' }),
            title: formatMessage({ id: 'adjustment.merge.n01.lbl17' }),
          });
          setMergeOpen(false);
          setModification({});
          history.goBack();
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
          setMergeOpen(false);
        }
      },
    });
  };

  // 提交
  const handleSubmitSuccess = (values) => {
    setMergeOpen(true);
    setSubmitData(values);
    // onSubmitSuccess(values);
  };

  const reasonLabel = (
    <div className="reason-label">
      <span style={{ color: '#D10000' }}>*</span>
      {/* 卡号合并原因 */}
      {formatMessage({ id: 'adjustment.members.merge.n01.lbl08' })}
    </div>
  );

  const handleMergeCancel = () => {
    setMergeOpen(false);
  };

  // 点击交换卡号
  const handleChangeCard = () => {
    // console.log( document.getElementsByClassName('admin-card-wrap')[0]);
    // const adminCardList=document.getElementsByClassName('admin-card-wrap')[0];
    // adminCardList.style.transform='translateX(750px)';

    // const secondaryCardList=document.getElementsByClassName('secondary-card-wrap')[0];
    // secondaryCardList.style.transform='translateX(-750px)';
    setAdminCard(secondaryCard);
    setSecondaryCard(adminCard);
  };

  // 主卡重置
  const handleAdminCard = () => {
    setAdminCard({});
  };

  // 副卡重置
  const handleSecondaryCard = () => {
    setSecondaryCard({});
  };

  // 底部重置按钮
  const resetData = () => {
    setAdminCard({});
    setSecondaryCard({});
    setValue('remark', '');
  };

  // 存储主卡id
  useMemo(() => {
    setAdminId(adminCard.id);
    setValue('masterCardId', adminCard.id);
  }, [adminCard.id, setValue]);

  useMemo(() => {
    setSecondaryId(secondaryCard.id);
    setValue('replicaCardId', secondaryCard.id);
  }, [secondaryCard.id, setValue]);

  // 设置主卡
  const onSetAdmin = (data) => {
    if (data.id === secondaryId) {
      setAdminCard(data);
      setSecondaryCard({});
    }
    setAdminCard(data);
  };

  // 设为副卡
  const onSetSecondary = (data) => {
    // 如果已经设为主卡了此时就不能设置为副卡，设为副卡时直接赋值给副卡
    if (data.id === adminId) {
      setAdminCard({});
      setSecondaryCard(data);
    }
    setSecondaryCard(data);
  };

  return (
    <div
      data-log={JSON.stringify({
        oid: 'page_manual_adjustment_member_adjust_card_merge',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      <SearchCondition
        searchRef={searchRef}
        query={query}
        handleSearch={(par) => handleSearch(par)}
        restClick={handleRestClick}
      ></SearchCondition>
      <CardConsolidationResult
        adminId={adminId}
        secondaryId={secondaryId}
        modification={modification}
        setModification={setModification}
        setPageData={handlePageChange}
        pagination={{
          pageNum,
          pageSize,
        }}
        onSetAdmin={(card) => onSetAdmin(card)}
        onSetSecondary={(card) => onSetSecondary(card)}
      ></CardConsolidationResult>
      <CardMergeStyled
        isHasAdminCard={adminCard?.name}
        isHasSecondaryCard={secondaryCard?.name}
      >
        <form onSubmit={handleSubmit(handleSubmitSuccess)}>
          <div className="merge-content-wrap">
            <Controller
              as={
                <Box className="admin-card-wrap">
                  <div className="admin-title">
                    {/* 主会员号 */}
                    {formatMessage({
                      id: 'adjustment.members.merge.n01.lbl04',
                    })}
                    <span>{adminCard.memberCode || '-'}</span>
                  </div>
                  <div className="admin-card-content">
                    <div className="card-content-top">
                      <div>
                        <span>
                          {/* 会员姓名 */}
                          {formatMessage({
                            id: 'adjustment.members.c01.lbl02',
                          })}
                        </span>
                        <div>{adminCard.name || '-'}</div>
                      </div>
                      <div>
                        <span>
                          {/* 会员等级 */}
                          {formatMessage({
                            id: 'adjustment.members.c01.lbl05',
                          })}
                        </span>
                        <div>{adminCard.level || '-'}</div>
                      </div>
                    </div>
                    <div className="card-content-top">
                      <div>
                        <span>
                          {/* 会员手机号 */}
                          {formatMessage({
                            id: 'adjustment.members.merge.n01.lbl06',
                          })}
                        </span>
                        <div>{adminCard.mobile || '-'}</div>
                      </div>
                      <div>
                        <span>
                          {/* 会员积分 */}
                          {formatMessage({
                            id: 'adjustment.members.merge.n01.lbl07',
                          })}
                        </span>
                        <div>
                          {adminCard.name ? adminCard.totalPoint || 0 : '-'}
                        </div>
                      </div>
                    </div>
                  </div>
                  <Button
                    data-log={JSON.stringify({
                      oid: createOid('ev'),
                      events: ['_ev'],
                      params: {
                        initUrl:
                          window.location.origin + window.location.pathname,
                      },
                    })}
                    className="reset-btn-admin"
                    onClick={() => handleAdminCard()}
                  >
                    {/* 重置 */}
                    {formatMessage({ id: 'comm.action.btn.06' })}
                  </Button>
                </Box>
              }
              name="masterCardId"
              error={Boolean(errors.masterCardId)}
              helperText={
                errors.masterCardId &&
                // '请设置主卡号'
                formatMessage({ id: 'adjustment.members.merge.n01.lbl16' })
              }
              control={control}
              rules={{
                required: true,
              }}
            ></Controller>
            <FormHelperText
              error={Boolean(errors.masterCardId)}
              className="error-wrap-second"
            >
              {Boolean(errors.masterCardId) &&
                // '请设置主卡号'
                formatMessage({ id: 'adjustment.members.merge.n01.lbl16' })}
            </FormHelperText>
            {/* masterCardId */}
            <span
              className="trans-btn"
              onClick={() =>
                (adminCard?.name || secondaryCard?.name) && handleChangeCard()
              }
            >
              <SvgIconML
                name={
                  adminCard?.name || secondaryCard?.name ? 'swap' : 'noSwap'
                }
                size={48}
              ></SvgIconML>
            </span>
            {/* replicaCardId */}
            <Controller
              as={
                <Box className="secondary-card-wrap">
                  <div className="secondary-title">
                    {/* 副会员号 */}
                    {formatMessage({
                      id: 'adjustment.members.merge.n01.lbl05',
                    })}
                    <span>{secondaryCard.memberCode || '-'}</span>
                  </div>
                  <div className="admin-card-content">
                    <div className="card-content-top">
                      <div>
                        <span>
                          {/* 会员姓名 */}
                          {formatMessage({
                            id: 'adjustment.members.c01.lbl02',
                          })}
                        </span>
                        <div>{secondaryCard.name || '-'}</div>
                      </div>
                      <div>
                        <span>
                          {/* 会员等级 */}
                          {formatMessage({
                            id: 'adjustment.members.c01.lbl05',
                          })}
                        </span>
                        <div>{secondaryCard.level || '-'}</div>
                      </div>
                    </div>
                    <div className="card-content-top">
                      <div>
                        <span>
                          {/* 会员手机号 */}
                          {formatMessage({
                            id: 'adjustment.members.merge.n01.lbl06',
                          })}
                        </span>
                        <div>{secondaryCard.mobile || '-'}</div>
                      </div>
                      <div>
                        <span>
                          {/* 会员积分 */}
                          {formatMessage({
                            id: 'adjustment.members.merge.n01.lbl07',
                          })}
                        </span>
                        <div>
                          {secondaryCard.name
                            ? secondaryCard.totalPoint || 0
                            : '-'}
                        </div>
                      </div>
                    </div>
                  </div>
                  <Button
                    data-log={JSON.stringify({
                      oid: createOid('ev'),
                      events: ['_ev'],
                      params: {
                        initUrl:
                          window.location.origin + window.location.pathname,
                      },
                    })}
                    className="reset-btn-secondary"
                    onClick={() => handleSecondaryCard()}
                  >
                    {/* 重置 */}
                    {formatMessage({ id: 'comm.action.btn.06' })}
                  </Button>
                </Box>
              }
              name="replicaCardId"
              error={Boolean(errors.replicaCardId)}
              helperText={
                errors.replicaCardId &&
                //  '请设置副卡号'
                formatMessage({ id: 'adjustment.members.merge.n01.lbl09' })
              }
              control={control}
              rules={{
                required: true,
              }}
            ></Controller>
            <FormHelperText
              error={Boolean(errors.replicaCardId)}
              className="error-wrap-admin"
            >
              {Boolean(errors.replicaCardId) &&
                //  '请设置副卡号'
                formatMessage({ id: 'adjustment.members.merge.n01.lbl09' })}
            </FormHelperText>
          </div>
          <div className="merge-reason-wrap">
            <FormControl className="single-select">
              <Controller
                // render={(rp) => (
                // )}
                as={
                  <TextField
                    name="remark"
                    variant="standard"
                    label={reasonLabel}
                    // value={rp.value}
                    // placeholder="请输入卡号合并原因"
                    placeholder={formatMessage({
                      id: 'adjustment.members.merge.n01.lbl10',
                    })}
                    // onChange={(e) => {
                    //   setValue('reason', e.target.value);
                    //   // setMemberCodeValue(e.target.value);
                    //   return rp.value;
                    // }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('remark', '');
                            }}
                            edge="end"
                          >
                            {watchReason && (
                              <ClearIcon className="clear-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    error={Boolean(errors.remark)}
                    helperText={
                      Boolean(errors.remark) &&
                      // '请输入卡号合并原因'
                      formatMessage({
                        id: 'adjustment.members.merge.n01.lbl10',
                      })
                    }
                  />
                }
                rules={{
                  required: true,
                }}
                name="remark"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
            </FormControl>
          </div>
          <div className="submit-btn-wrap">
            <div className="btn-wrap">
              <Button
                variant="contained"
                color="secondary"
                // className="coupons-setting-button"
                onClick={() => history.goBack()}
                // onClick={() => history.push('/marketing/scene')}
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
              >
                {/* 退出 */}
                {formatMessage({ id: 'comm.action.btn.16' })}
              </Button>
              <Button
                data-log={JSON.stringify({
                  oid: createOid('ec'),
                  events: ['_ev', '_ec'],
                  params: {
                    initUrl: window.location.origin + window.location.pathname,
                  },
                })}
                variant="contained"
                color="secondary"
                type="reset"
                className="reset"
                //点击重置主卡副卡全部重置
                onClick={() => resetData()}
                startIcon={
                  <ReplayIcon sx={{ width: '16px', height: '16px' }} />
                }
              >
                {/* 重置 */}
                {formatMessage({ id: 'comm.action.btn.06' })}
              </Button>
              <Button
                data-log={JSON.stringify({
                  oid: createOid('ev'),
                  events: ['_ev'],
                  params: {
                    initUrl: window.location.origin + window.location.pathname,
                  },
                })}
                ref={saveRef}
                variant="contained"
                type="submit"
                className="search"
                startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
                // onClick={onSubmit}
              >
                {/* 确认 */}
                {formatMessage({ id: 'comm.action.btn.07' })}
              </Button>
            </div>
          </div>
          <ModalML
            open={mergeOpen}
            setOpen={setMergeOpen}
            onCancel={handleMergeCancel}
            // title={'合并会员号确认'}
            title={formatMessage({ id: 'adjustment.merge.n01.lbl11' })}
            onClose={handleMergeCancel}
            isHasBcg={false}
          >
            <MergeModal
              handleMergeCancel={handleMergeCancel}
              onConfirm={onSubmitSuccess}
            ></MergeModal>
          </ModalML>
        </form>
      </CardMergeStyled>
    </div>
  );
};
